import { Loader } from "lucide-react";
import { ButtonHTMLAttributes, ReactNode } from "react";
import { Button, ButtonProps } from "../ui/button";

type ButtonWithLoaderProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonProps & {
    children: ReactNode;
    pending: boolean;
  };

export default function ButtonWithLoader({ children, pending, ...rest }: ButtonWithLoaderProps) {
  return (
    <Button className={pending ? "cursor-not-allowed" : ""} disabled={pending} {...rest}>
      {children}
      <span
        className={`inline-block overflow-hidden transition-all ${pending ? "ml-2 w-4 opacity-100" : "ml-0 w-0 opacity-0"}`}
      >
        <Loader size={16} className="animate-spin" />
      </span>
    </Button>
  );
}

// (<Button className="relative" disabled={pending} {...rest}>
//   <p className={cn("", pending ? "opacity-0" : "opacity-100")}>{children}</p>
//   <div
//     className={cn(
//       "absolute inset-0 flex animate-spin items-center justify-center",
//       pending ? "opacity-100" : "opacity-0",
//     )}
//   >
//     <LoaderCircle size={16} />
//   </div>
// </Button>)
